import { render, staticRenderFns } from "./DefaultContainer.vue?vue&type=template&id=23756000&scoped=true"
import script from "./DefaultContainer.vue?vue&type=script&lang=js"
export * from "./DefaultContainer.vue?vue&type=script&lang=js"
import style0 from "./DefaultContainer.vue?vue&type=style&index=0&id=23756000&prod&lang=css"
import style1 from "./DefaultContainer.vue?vue&type=style&index=1&id=23756000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23756000",
  null
  
)

export default component.exports